var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"name":_vm.name,"width":800,"height":600}},[_c('div',{staticClass:"modal-create-population-container"},[_c('iframe',{attrs:{"src":_vm.apolloDomain + '/apollo/vheart/create_population',"width":"100%","height":"100%"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }